<h2 class="app-manage-subscription-title" [kitText]="titleModel"></h2>

<span class="app-manage-subscription-content" [kitText]="contentModel"></span>

<span class="app-manage-subscription-footnote" [kitText]="footnoteModel"></span>

<kit-bs-checkbox [kitCheckbox]="checkboxModel"></kit-bs-checkbox>

<kit-bs-button [kitModel]="actionModel"></kit-bs-button>
